export class LineSpanInfo {
  private _startRow: number;
  private _lineSpan: number;

  constructor(startRow: number, lineSpan: number) {
    this._startRow = startRow;
    this._lineSpan = lineSpan;
  }

  public get startRow(): number {
    return this._startRow;
  }

  public get lineSpan(): number {
    return this._lineSpan;
  }
}
